import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

interface IPageControlBarProps {
    pageNumber: number,
    pageCount: number,
    rowCount: number,
    onChangePage: (page: number) => void;
}

const isInteger = (str) => {
    return /^-?\d+$/.test(str);
}

export default function PageControlBar({ pageNumber, pageCount, rowCount, onChangePage }: IPageControlBarProps) {
    const [customPageNumber, setCustomPageNumber] = useState(pageNumber);

    useEffect(() => {
        setCustomPageNumber(pageNumber);
    }, [pageNumber])

    const pageNumberOnChange = (event: any) => {
        const newPageNumber = event.target.value;
        if (!isNaN(newPageNumber) && isInteger(newPageNumber)) {
            if (newPageNumber > 0 && newPageNumber <= pageCount)
                setCustomPageNumber(newPageNumber);
        }
    }

    const manualChangePageNumber = () => {
        if (customPageNumber > 0 && customPageNumber <= pageCount) {
            onChangePage(customPageNumber);
        }
    }

    const pageUp = () => {
        if (pageNumber < pageCount) {
            onChangePage(pageNumber + 1);
        }
    }

    const pageDown = () => {
        if (pageNumber >= 1) {
            onChangePage(pageNumber - 1);
        }
    }

    return (
        <Grid container justifyContent="space-between" spacing={1} style={{ padding: '8px' }}>
            <Grid>
                <Button variant="contained" color="secondary" style={{ marginRight: '8px' }} onClick={pageDown} disabled={pageNumber <= 1}>Previous Page</Button>
                <Button variant="contained" color="primary" style={{ marginLeft: '8px', marginRight: '8px' }} onClick={pageUp} disabled={pageNumber === pageCount}>Next Page</Button>
                <TextField
                    id="standard-name"
                    value={customPageNumber}
                    onChange={pageNumberOnChange}
                    margin="none"
                    size="small"
                    style={{ width: '75px', marginLeft: '8px', marginRight: '8px' }}
                />
                <label> of {pageCount}</label>
                <Button variant="contained" color="secondary" style={{ marginLeft: '8px' }} disabled={customPageNumber + 1 <= 0 || customPageNumber > pageCount} onClick={manualChangePageNumber}>Apply</Button>
            </Grid>
            <Grid>
                <label>{rowCount} results found.</label>
            </Grid>
        </Grid>
    );
}
